import React from "react";
import {Card} from "primereact/card";
import {Button} from "primereact/button";
import {useAuth0} from "@auth0/auth0-react";
import FullscreenLayout from "@/Themes/Default/Layouts/FullscreenLayout";

const InactivePermissionsPage = () => {
    const {
        logout
    } = useAuth0();

    return (
        <FullscreenLayout>
            <Card>
                <div className="public-form login-form flex flex-column gap-2">
                    <h3 className="m-0">Access Restricted</h3>
                    <p>You do not currently have active access to Nightingale because your permissions are inactive.</p>
                    <p>Please contact your administrator to have your access restored. Once your permissions are reactivated, you will be able to sign in again.</p>
                    <Button
                        className="w-full block"
                        label="Logout"
                        onClick={() => logout()}
                    />
                </div>
            </Card>
        </FullscreenLayout>
    );
};

export default InactivePermissionsPage;
